<app-sender-arend [telegramService]="telegramService" *ngIf="(authService.mode$ | async) == 'Старт' || (authService.mode$ | async) == 'Аренда'"></app-sender-arend>
<app-sender-forgot *ngIf="(authService.mode$ | async) == 'Восстановление';"></app-sender-forgot>
<app-sender-register [telegramService]="telegramService" *ngIf="(authService.mode$ | async) == 'Регистрация'"></app-sender-register>
<app-sender-auth [telegramService]="telegramService" *ngIf="(authService.mode$ | async) == 'Авторизация'"></app-sender-auth>



